import { Box, Image } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { TransitionalVideoProps } from '../interfaces/components';
import SkipVideo from '../assets/images/SkipVideo.png';
import SkipVideoAR from '../assets/images/SkipVideoAR.png';

function TransitionVideo({
  activeLocale,
  videoURL,
  room,
  playing,
  setPlaying,
  resetTransitionVideo,
}: TransitionalVideoProps) {
  const [alreadyGone, setAlreadyGone] = useState(false);
  const [showSkip, setShowSkip] = useState(false);
  const [halted, setHalted] = useState(false);

  useEffect(() => {
    if (halted) {
      setTimeout(() => {
        setPlaying();
        setShowSkip(false);
        setAlreadyGone(false);
        resetTransitionVideo();
      }, 500);
    }
  }, [halted]);

  return (
    <Box
      className="transition-ui"
      position="fixed"
      width="100%"
      zIndex="999999"
      h="100%"
      top="0"
      opacity={playing ? 1 : 0}
      visibility={playing ? 'visible' : 'hidden'}
      transition={playing ? 'none' : 'visibility 0s linear 1s, opacity 1s'}
    >
      <Box className="transition-player" id="transition-player">
        <ReactPlayer
          progressInterval={1}
          onProgress={(prog) => {
            const percentagePlayed = Math.floor(prog.played * 100);
            if (percentagePlayed === 5) {
              if (!alreadyGone) {
                console.log('Goto Scene ', room);
                window.GotoScene(room);
                setAlreadyGone(true);
              }
            }
            if (percentagePlayed === 15) {
              setShowSkip(true);
            }
          }}
          id="transition-video"
          height="100%"
          width="100%"
          style={{ minHeight: '100vh' }}
          loop={false}
          muted
          controls={false}
          playing={playing}
          url={videoURL}
          onEnded={() => {
            setPlaying();
            setShowSkip(false);
            setAlreadyGone(false);
            setTimeout(() => {
              resetTransitionVideo();
            }, 500);
          }}
          onError={() => {
            setHalted(true);
          }}
          playsinline
        />
      </Box>
      <Image
        opacity={showSkip ? 1 : 0}
        visibility={showSkip ? 'visible' : 'hidden'}
        transition="all .5s"
        src={activeLocale === 'ar' ? SkipVideoAR : SkipVideo}
        margin="0 auto"
        zIndex="1"
        position="absolute"
        left="0"
        right="0"
        width={['100px', '100px', '150px', '150px', '150px', '150px']}
        bottom="2%"
        onClick={() => {
          setPlaying();
          setShowSkip(false);
          setAlreadyGone(false);
          setTimeout(() => {
            resetTransitionVideo();
          }, 500);
        }}
        aria-label="Skip The Video"
        cursor="pointer"
      />
    </Box>
  );
}

export default TransitionVideo;
